const petcoTypeSystem = {
  bodyFontFamily: ['PetcoCircularTT', 'sans-serif'].join(),
  headingFontFamily: ['PetcoCircularTT', 'sans-serif'].join(),

  headingLineHeightMobile: '1.15',
  headingMicroMobile: '.875rem',
  headingSmallMobile: '1rem',
  headingMediumMobile: '1.125rem',
  headingLargeMobile: '1.25rem',
  headingXLargeMobile: '1.5rem',

  headingLineHeight: '1.15',
  headingMicro: '.875rem',
  headingXSmall: '1rem',
  headingSmall: '1.125rem',
  headingMedium: '1.25rem',
  headingLarge: '1.375rem',
  headingXLarge: '1.563rem',

  bodyLineHeight: '1.15',
  bodyMicro: '.688rem',
  bodySmall: '.813rem',
  bodyMedium: '.938rem',
  bodyLarge: '1.125rem',
  bodyXLarge: '1.188rem',

  extraLight: '200',
  light: '300',
  regular: '400',
  semiBold: '600',
  bold: '700',
  extraBold: '800',
  black: '900',

};

export default petcoTypeSystem;
